export default __webpack_public_path__ + "static/media/missing-car.48d1a13d.svg";